module.exports = __webpack_public_path__ + "img/2020_11_07_mushroom_man.ee08a168.jpg";